import { Button } from '@consigli/facade';
import {
  DndContext,
  KeyboardSensor,
  MouseSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { restrictToWindowEdges } from '@dnd-kit/modifiers';
import { useTranslation } from 'react-i18next';
import { FaBan } from 'react-icons/fa6';

import { MultipleSelectionDialog } from '@/components/multiple-selection-dialog';
import { snapCenterToCursor } from '@/util/dragging-util';

interface ConfirmProjectRemovalPopupProps {
  showButtons: boolean;
  setShowButtons: React.Dispatch<React.SetStateAction<boolean>>;
  removeProject: () => void;
}

export const ConfirmProjectRemovalPopup = (props: ConfirmProjectRemovalPopupProps) => {
  const { showButtons, setShowButtons, removeProject } = props;
  const { t } = useTranslation();
  const sensors = useSensors(
    useSensor(MouseSensor),
    useSensor(KeyboardSensor),
    useSensor(PointerSensor),
  );

  if (!showButtons) {
    return <></>;
  }
  return (
    <DndContext sensors={sensors} modifiers={[snapCenterToCursor, restrictToWindowEdges]}>
      <MultipleSelectionDialog
        className="w-[320px]"
        dragId="confirm-project-removal"
        onClose={() => setShowButtons(false)}
      >
        <div className="flex flex-col w-full gap-3">
          <p className="text-center font-medium">{t('invite-user.remove-user')}</p>
          <div className="flex w-full justify-between items-center gap-2">
            <Button className="grow" rounded secondary onClick={() => setShowButtons(false)}>
              {t('invite-user.cancel')}
            </Button>
            <Button
              className="grow"
              icon={FaBan}
              iconColor="red"
              rounded
              secondary
              onClick={removeProject}
            >
              {t('invite-user.remove-access')}
            </Button>
          </div>
        </div>
      </MultipleSelectionDialog>
    </DndContext>
  );
};
